export const MenuItems = [
    {
        title: 'Software',
        url: '#software',
        cName: 'nav-links'
    },
    {
        title: 'Timeline',
        url: '#timeline',
        cName: 'nav-links'
    },
    {
        title: 'Projects',
        url: '#projects',
        cName: 'nav-links'
    },
    {
        title: 'Education',
        url: '#education',
        cName: 'nav-links'
    },
    {
        title: 'Awards',
        url: '#awards',
        cName: 'nav-links'
    },
    {
        title: 'Contact',
        url: '#contact',
        cName: 'nav-links'
    },
]